<template>
	<div class="row">
		<div class="col-sm-12 col-md-12 col-lg-7 m-sm-4 m-md-4 p-3 custom-rounded-15 shadow-md mt-5">
			<div class="d-flex py-2 bg-warning rounded  shadow-md">
				<div
					v-for="(status, index) in multiSelectState.leadStatus"
					class="d-flex align-items-center justify-content-center me-3"
					:key="`lead-${index}`"
				>
					<span
						:class="`cursor-pointer px-2 py-1 ${
							masterStore.state.data.leadStatus === status
								? 'bg-success text-dark status-arrow'
								: ''
						}`"
					>
						{{ status }}
					</span>
				</div>
			</div>
			<div
				v-if="masterStore.state.data.leadStatus === 'Working'"
				class="d-flex py-2 bg-warning rounded align-items-center border-top border-light"
			>
				<div
					v-for="(status, index) in multiSelectState.workingSubStatus"
					class="d-flex align-items-center justify-content-center me-3"
					:key="`lead-${index}`"
				>
					<span
						:class="`cursor-pointer px-2 py-1 ${
							masterStore.state.data.leadSubStatus === status
								? 'bg-success text-dark status-arrow'
								: ''
						}`"
					>
						{{ status }}
					</span>
				</div>
			</div>
			<div
				v-if="masterStore.state.data.leadStatus === 'Booked'"
				class="d-flex py-2 bg-warning rounded align-items-center border-top border-light"
			>
				<div
					v-for="(status, index) in multiSelectState.bookingSubStatus"
					class="d-flex align-items-center justify-content-center me-3"
					:key="`lead-${index}`"
				>
					<span
						:class="`cursor-pointer px-2 py-1 ${
							masterStore.state.data.leadSubStatus === status
								? 'bg-success text-dark status-arrow'
								: ''
						}`"
					>
						{{ status }}
					</span>
				</div>
			</div>
			<div class=" my-4 py-4">
				<div
					v-if="
						((masterStore.state.data.leadStatus === 'Working' &&
						masterStore.state.data.leadSubStatus === 'Ops') || masterStore.state.data.leadStatus === 'Proposal Sent' || masterStore.state.data.leadStatus === 'Negotiating') && (masterStore.state.data.package?.itinerary && !masterStore.state.data.package?.itinerary.length)
					"
					class="d-flex align-items-center  bg-danger  rounded p-2 shadow-md"
				>
					<h3 class="text-light mb-0">Attention: Please Add an Itinerary to send(email/whatsapp)/preview proposal  </h3>
				</div>
			</div>
			<div class="col-sm-12">
				<h2 class="text-center py-2 bg-warning rounded w-100">Details</h2>
			</div>
			<div class="row mt-4">
				<InfoCardComponent
					title="Customer Name"
					:text="`${masterStore.state.data?.name?.salutation} ${masterStore.state.data?.name?.firstName} ${masterStore.state.data?.name?.lastName || '-'}`"
				/>
				<InfoCardComponent
					title="Mobile Number"
					:text="masterStore.state.data?.phone || '-'"
				/>

				<InfoCardComponent
					title="Email Address"
					:text="masterStore.state.data.email || '-'"
				/>
								
				<InfoCardComponent
					title="Address"
					:text="masterStore.state.data?.address?.loc || '-'"
				/>

				<InfoCardComponent
					title="City"
					:text="masterStore.state.data?.address?.city || '-'"
				/>
				<InfoCardComponent
					title="Customer Type"
					:text="masterStore.state.data?.customerType"
				/>

				<InfoCardComponent
					title="Lead Source"
					:text="masterStore.state.data?.leadSource"
				/>
				<InfoCardComponent
					title="lead Priority"
					:text="masterStore.state.data?.leadPriority"
				/>
				<InfoCardComponent
					title="Trip Type"
					:text="masterStore.state.data?.tripType"
				/>

				<InfoCardComponent
					title="Lead Status"
					:text="masterStore.state.data.leadStatus"
				/>
				<InfoCardComponent
					title="Assigned To"
					:text="`${masterStore.state.data?.assignedTo?.firstName} ${masterStore.state.data?.assignedTo?.lastName}`"
				/>
				<InfoCardComponent
					title="Current Assigned User"
					:text="
						masterStore.state.data?.currentUser &&
						masterStore.state.data.currentUser?.firstName
							? `${masterStore.state.data?.currentUser?.firstName} ${masterStore.state.data?.currentUser?.lastName}`
							: `${masterStore.state.data?.assignedTo?.firstName} ${masterStore.state.data?.assignedTo?.lastName}`
					"
				/>

				<InfoCardComponent
					title="Created At"
					:text="
						masterStore.state.data?.createdAt
							.split('T')
							.join(', ')
							.replace(/([:][0-9][0-9])[.]\w+/g, '') || '-'
					"
				/>

				<InfoCardComponent
					title="Budget"
					:text="
					   	masterStore.state.data?.package?.budget || '-'
					"
					dataKey="&#x20B9;"
				/>
				
				
			</div>

			<div v-if="masterStore.state.data.package?.itinerary" class="row mt-4">
				<h2 class="text-dark bg-warning py-2 rounded d-flex align-items-center justify-content-center cursor-pointer" @click="toggleItinerary()">   <span class="d-flex align-items-center me-2"><i :class="` mt-1 bi ${ showItinerary ? 'bi-eye-slash': 'bi-eye'} me-2`"></i> {{ showItinerary ? 'Hide' : 'Show' }}</span> Itinerary</h2>
				<div v-if="showItinerary" class="col-sm-12">
					<div
						v-for="(itinerary, index) in masterStore.state.data.package.itinerary"
						:key="`${index}-itinerary`"
						class=" p-2"
					>
						<div class="card">
							<div class="row g-0">
								<div
									class="col-md-2 d-flex flex-column justify-content-evenly align-items-center overflow-hidden"
								>
									<div class="profile">
										<img
											class="user-profile round-img shadow-lg"
											:src="`${
												itinerary?.sightSeeing instanceof Array
													? itinerary?.sightSeeing[0]?.images[0]
													: ''
											}`"
											alt="sight"
										/>
									</div>
								</div>
								<div class="card-body col-sm-8">
									<h4 class="card-title pb-1">{{ itinerary.title }}</h4>
									<div class="row">
										<div class="col-sm-3">
											<p class="card-text pb-1"><b>Day </b>{{ itinerary.day }}</p>
										</div>
										<div class="col-sm-3">
											<p class="card-text pb-1">
												<b>City: </b>{{ itinerary.city.name }}
											</p>
										</div>
										<div class="col-sm-3">
											<p class="card-text pb-1">
												<b>Place: </b>{{ itinerary.placeName }}
											</p>
										</div>
										<div class="col-sm-3">
											<p class="card-text pb-1">
												<b>Meals: </b
												><span
													v-for="(meal, mealIndex) in itinerary.meal"
													:key="`${mealIndex}-meal`"
													>{{ meal }},
												</span>
											</p>
										</div>
									</div>

									<div
										v-for="(sight, index) in itinerary.sightSeeing"
										:key="`${index}-sight`"
										class="row my-2"
									>
										<h6>Sight {{ index + 1 }}</h6>
										<div class="col-sm-3">
											<p><b>Activity:</b> {{ sight.activity }}</p>
										</div>
										<div class="col-sm-3">
											<p><b>Duration:</b> {{ sight.duration }}</p>
										</div>
										<div class="col-sm-3">
											<p><b>Start Time:</b> {{ sight.startTime }}</p>
										</div>
										<div class="col-sm-3">
											<p><b>End Day:</b> {{ sight.closeDay }}</p>
										</div>
									</div>
									<div class="row">
										<p class="card-text pb-1">
											<b>Detail: </b>{{ itinerary.details }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			
			
			<div class="row mt-5">
				<div class="col-sm-12">
					<h2 class="text-center py-2 bg-warning rounded w-100">Actions</h2>
				</div>
				<div v-if="showComponent.assignTo" class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setAssignedTo"
						:options="multiSelectState.usersOptions"
						:defaultData="[masterStore.state.data?.assignedTo?._id]"
						rules="required"
						name="Change Assigned Lead Owner"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>

				<div v-if="showComponent.passTo" class="col-sm-6 mb-4">
					<BaseMultiSelect
						v-if="masterStore.state.data?.currentUser"
						@update:value="setCurrentUser"
						:options="multiSelectState.usersOptions"
						:defaultData="
							masterStore.state.data?.currentUser._id ||
							masterStore.state.data?.assignedTo?._id
						"
						rules="required"
						name="Pass Lead To"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
					<BaseMultiSelect
						v-else
						@update:value="setCurrentUser"
						:options="multiSelectState.usersOptions"
						rules="required"
						name="Pass Lead To"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>

				<div class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setStatus"
						:options="multiSelectState.leadStatus"
						:defaultData="[masterStore.state.data?.leadStatus]"
						rules="required"
						name="Lead Status"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>
				<div v-if="masterStore.state.data.leadStatus === 'Working'" class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setSubStatus"
						:options="multiSelectState.workingSubStatus"
						:defaultData="masterStore.state.data?.leadSubStatus"
						rules="required"
						name="Working Sub Status"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>
				<div v-if="masterStore.state.data.leadStatus === 'Booked'" class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setSubStatus"
						:options="multiSelectState.bookingSubStatus"
						:defaultData="masterStore.state.data?.leadSubStatus"
						rules="required"
						name="Booking Sub Status"
						@valError="valError"
						@valSuccess="valSuccess"
					/>

				</div>

				<div class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setPriority"
						:options="multiSelectState.leadPriority"
						:defaultData="[masterStore.state.data?.leadPriority]"
						rules="required"
						name="Lead Priority"
						@valError="valError"
						@valSuccess="valSuccess"
					/>

				</div>

				<div v-if="masterStore.state.data?.package?.packageId?.includedDeal" class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setPackageDeal"
						:options="multiSelectState.packageDealNames"
						:defaultData="masterStore.state.data?.selectedDeal ? masterStore.state.data?.selectedDeal : ''"
						rules="required"
						name="Select Package Deal"
						@valError="valError"
						@valSuccess="valSuccess"
					/>

				</div>
				

				<div  class="col-sm-6 mb-4">
					<BaseMultiSelect
						@update:value="setPricePreference"
						:options="multiSelectState.pricePreference"
						:defaultData="masterStore.state.data?.pricePreference ? masterStore.state.data?.pricePreference : ''"
						rules="required"
						name="Package Price Preference"
						@valError="valError"
						@valSuccess="valSuccess"
					/>

				</div>
			</div>
			
		</div>
		<div class="col-sm-12 col-md-12 col-lg-4 m-sm-4 m-md-4 ms-lg-3  custom-rounded-15 shadow-md mt-5">
			<div class="row">
				<div
					class="col-sm-12 p-3 mb-5 custom-dark-bg custom-rounded-15 shadow-md"
				>
					<BaseTextArea
						v-model="data.notes"
						name="Notes"
						label="Notes"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
					<BaseButton
						v-if="data.notes"
						class="btn btn-primary form-control mt-2"
						@on:Click="saveNote"
						label="Save"
					/>
				</div>
				<div
					v-if="
						masterStore.state.data?.notes instanceof Array &&
						masterStore.state.data?.notes.length
					"
					class="col-sm-12  py-3 mb-5 custom-dark-bg custom-rounded-15 shadow-md my-2 py-2 px-1"
				>	
					<h2 class="text-dark bg-warning rounded px-2 mb-4">Added Notes</h2>
					<div class=" custom-height overflow-auto">
						
						<p
							v-for="(note, index) in masterStore.state.data.notes"
							:key="`${index}-note`"
							class=" bg-warning rounded my-1 ps-2 py-1"
						>
							{{ `${note?.string} ` }}
							<span class="fw-light lh-1 text-dark">
								{{`by ${note?.user?.firstName} ${note?.user?.lastName}`}} at 
								<i class="bi bi-clock-history"></i>
								{{
									` ${
										note?.date
											? note.date
													.split("T")
													.join(", ")
													.replace(/([:][0-9][0-9])[.]\w+/g, "")
											: "-"
									}`
								}}</span
							>
						</p>
					</div>
				</div>
				<div
					v-if="masterStore.state.data?.logs.length"
					class="col-sm-12 py-3 mb-5 custom-dark-bg custom-rounded-15 shadow-md my-2 py-2 px-1"
				>
					<h2 class="text-dark bg-warning ps-2 rounded mb-4">Lead History</h2>
					<div class="custom-height overflow-auto">
					<p
						v-for="(log, index) in masterStore.state.data.logs"
						:key="`${index}-log`"
						class="text-dark bg-warning rounded my-1 px-2 py-1"
					>
						{{ `${log?.string} ` }}
						<span class="fw-light lh-1 text-dark">
							{{` by ${log?.user?.firstName} ${log?.user?.lastName}`}} at 
							<i class="bi bi-clock-history"></i>
							{{
								` ${
									log?.date
										? log.date
												.split("T")
												.join(", ")
												.replace(/([:][0-9][0-9])[.]\w+/g, "")
										: "-"
								}`
							}}</span
						>
					</p>
					</div>
					
				</div>

				
				<div v-if="masterStore.state.data?.selectedDeal" class="row ">
					<div class="col-sm-12">
						<PackageHotelDealCard 
						v-if="masterStore.state.data?.selectedDeal === 'bronzePackage'" 
						name="Bronze" 
						:dealData="masterStore.state.data?.package.packageId.bronzePackage" 
						:starCount="1"/>
						<PackageHotelDealCard 
						 v-if="masterStore.state.data?.selectedDeal === 'platinumPackage'"
						 name="Platinum" 
						 :dealData="masterStore.state.data?.package.packageId.platinumPackage" 
						 :starCount="2"/>
						<PackageHotelDealCard 
						v-if="masterStore.state.data?.selectedDeal === 'silverPackage'"
						name="Silver" 
						:dealData="masterStore.state.data?.package.packageId.silverPackage" 
						:starCount="3"/>
						<PackageHotelDealCard 
						v-if="masterStore.state.data?.selectedDeal === 'goldPackage'"
						name="Gold" 
						:dealData="masterStore.state.data?.package.packageId.goldPackage" 
						:starCount="4"/>
						<PackageHotelDealCard 
						 v-if="masterStore.state.data?.selectedDeal === 'luxuryPackage'"
						name="Luxury" 
						:dealData="masterStore.state.data?.package.packageId.luxuryPackage" 
						:starCount="5"/>
					</div>
				</div>
				<div v-if="masterStore.state.data?.payments && masterStore.state.data?.payments.length" class="col-sm-12 shadow-md rounded p-2">
					<h2 class="text-dark bg-warning rounded px-2 mb-4">Payments</h2>
					<div class="paymentWrap">
						<div class="mt-2 row mx-1 border border-warning " 
						v-for="(payment, index) in masterStore.state.data?.payments"
						:key="`${index}-payments-${Math.random()}`"
						>	
							<InfoCardComponent
								title="Total"
								:text="payment.totalAmount ? payment.totalAmount : '-'"
								dataKey="&#x20B9;"
							/>
							<InfoCardComponent
								title="Paid"
								:text="payment.advance ? payment.advance : '-'"
								dataKey="&#x20B9;"
							/>
							<InfoCardComponent
								title="Remaining"
								:text="payment.balance ? payment.balance : '-'"
								dataKey="&#x20B9;"
							/>
							<InfoCardComponent
								title="Approved"
								:text="payment?.verified ? 'Yes' : 'No'"
							/>
							<div v-if="showComponent.approvePayment" class="col-sm-12">
								<div class="row">
									<div class="col-6 my-2">
										<button v-if="!payment?.verified" @click.stop="paymentAction('verify',payment.count)" class="btn btn-danger w-100">Approve Receipt</button>
									</div>
									<div class="col-6 my-2">
										<button v-if="!payment?.rejected" @click.stop="paymentAction('reject', payment.count)" class="btn btn-danger w-100">Reject Receipt</button>
									</div>
								</div>
							</div>
							
							<!-- <button v-if="!payment?.verified" @click.stop="paymentAction(payment.count)" class="btn btn-danger">Approve Receipt</button> -->
						</div>
						<div  v-if="showComponent.approvePayment"  class="row mx-1  mt-4 mb-2 border border-danger">
							<div class="col-6 py-2">
								<button v-if="masterStore.state.data?.payments.length && !masterStore.state.data?.payments[masterStore.state.data?.payments.length -1].verified" @click.stop="paymentAction('accept_all', 0)" class="btn btn-danger w-100">Approve All</button>
							</div>
							<div class="col-6 py-2">
								<button v-if="masterStore.state.data?.payments.length && !masterStore.state.data?.payments[masterStore.state.data?.payments.length -1].rejected" @click.stop="paymentAction('reject_all', 0)" class="btn btn-danger w-100">Reject All</button>
							</div>

						</div>
						
					</div>
				</div>
				
			</div>
		</div>

		<!-- Modal -->
		<div
			:class="`modal fade ${model.active ? 'show' : ''}`"
			id="staticBackdrop"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title" id="staticBackdropLabel">Add a reason</h6>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							@click="modelEvent('close')"
						></button>
					</div>
					<div class="modal-body">
						<BaseTextArea
							v-model="data.notes"
							name="Notes"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-primary"
							@click="modelEvent('save')"
						>
							Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { reactive, inject, ref } from "vue";
	import toast from "@/config/toast";
	import API from "@/config/api";
	import Data from "@/helpers/dataHelper";

	import BaseTextArea from "./BaseTextArea";
	import InfoCardComponent from "./InfoCardComponent";
	import BaseMultiSelect from "./BaseMultiSelect";
	import BaseButton from "./BaseButton";
	import PackageHotelDealCard from "./packageHotelDealCard.vue"
	

	export default {
		name: "LeadShow",
		components: {
			BaseTextArea,
			InfoCardComponent,
			BaseMultiSelect,
			BaseButton,
			PackageHotelDealCard
		},

		setup() {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const data = reactive({
				notes: null,
				leadPriority: null,
				leadStatus: null,
				currentUser: null,
				assignedTo: null,
				leadSubStatus: null,
				selectedDeal: null,
				pricePreference: null,
			});


			const multiSelectState = reactive({
				users: [],
				usersOptions: [],
				leadPriority: Data.leadPriority,
				leadStatus: Data.leadStatus,
				workingSubStatus: Data.workingSubStatus,
				bookingSubStatus: Data.bookingSubStatus,
				packageDealNames: [],
				pricePreference: [
					{ label: "Season Price", value: "SP" },
					{ label: "Off Season Price", value: "OSP" }
				],
			});

			const model = reactive({
				active: false,
			});

			const showComponent = reactive({
				passTo: false,
				assignTo: false,
				approvePayment: false,
			});

			const api = reactive({
				isLoading: false,
			});

			if (masterStore.state.data?.leadPriority) {
				// TODO: code
			}

			if (masterStore.state.data?.logs && masterStore.state.data?.logs.length) {
				masterStore.methods.changeData({ ...masterStore.state.data, logs: masterStore.state.data?.logs.reverse() });
			}

			if (masterStore.state.data?.notes && masterStore.state.data?.notes.length) {
				masterStore.methods.changeData({ ...masterStore.state.data, notes: masterStore.state.data?.notes.reverse() });
			}

			if (masterStore.state.data?.package.packageId?.includedDeal) {
				const packageDealKeys = [
					"Luxury",
					"Gold",
					"Silver",
					"Platinum",
					"Bronze",
				]

				let dealsArray = [];

				packageDealKeys.map(dealKey => {
					if (
						masterStore.state.data?.package?.packageId[`${dealKey.toLowerCase()}Package`] &&
						Array.isArray(masterStore.state.data?.package?.packageId[`${dealKey.toLowerCase()}Package`]) &&
						masterStore.state.data?.package?.packageId[`${dealKey.toLowerCase()}Package`].length
					) {
						dealsArray.push({ label: `${dealKey} Package`, value: `${dealKey.toLowerCase()}Package` });
					}
				});

				multiSelectState.packageDealNames = [ { label: "All", value: "" },...dealsArray]
			}

			if (
				store.state.user.role.includes(process.env.VUE_APP_USER_ADMIN) ||
				store.state.user.role.includes(
					process.env.VUE_APP_USER_GENERAL_MANAGER,
				) ||
				store.state.user.role.includes(process.env.VUE_APP_USER_TEAM_LEAD) ||
				store.state.user.role.includes(
					process.env.VUE_APP_USER_SALES_MANAGER,
				) ||
				store.state.user.role.includes(
					process.env.VUE_APP_USER_AREA_SALES_MANAGER,
				)
			) {
				showComponent.assignTo = true;
				showComponent.passTo = true;
				
			}

			if (!store.state.user.role.includes(process.env.VUE_APP_USER_SALES_EXECUTIVE)) {
				showComponent.approvePayment = true;
			}

			const setStatuses = () => {
				const status = masterStore.state.data.leadStatus;
				let statuses = [...multiSelectState.leadStatus];
				let index = statuses.indexOf(status);
				if (status === "Negotiating") {
					index = index - 1;
				}
				statuses = statuses.slice(index);
				multiSelectState.leadStatus = statuses;

				if (status === "Working") {
					showComponent.workingSubStatus = true;
				}

				if (status === "Booked") {
					showComponent.bookingSubStatus = true;
				}
			};
			setStatuses();

			const toggleModel = () => (model.active = !model.active);

			const getUsers = async () => {
				try {
					const users = await API.privateRequest.get("/users?filter=1");
					multiSelectState.users = users.data.data;
					multiSelectState.usersOptions = users.data.data.map((item) => {
						return {
							value: item._id,
							label: `${item.firstName} ${item.lastName}`,
						};
					});
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			getUsers();

			const setAssignedTo = (id) => {
				data.assignedTo = id;
				toggleModel();
			};

			const setCurrentUser = (id) => {
				data.currentUser = id;
				toggleModel();
			};

			const setStatus = (status) => {
				data.leadStatus = status;
				toggleModel();
			};

			const setPriority = (id) => {
				data.leadPriority = id;
				toggleModel();
			};

			const setSubStatus = (subStat) => {
				data.leadSubStatus = subStat;
				toggleModel();
			};

			const setPackageDeal = (deal) => {
				data.selectedDeal = deal
				updateLead("selectedDeal");

			}

			const setPricePreference = (preference) => {
				data.pricePreference = preference
				updateLead("pricePreference");
			}

			const updateLead = async (field) => {
				try {
					if (!field) return;

					await API.privateRequest.patch(
						`/leads/${masterStore.state.data._id}`,
						{
							[field]: data[field],
						},
					);

					if (model.active) toggleModel();

					toast.success(`${field} updated !`);

					// masterStore.state.data[Object.keys(updateData)[0]] =
					// 	updateData[Object.keys(updateData)[0]];
					if (
						field === "leadSubStatus" ||
						field === "leadStatus" ||
						field === "leadPriority" ||
						field === "selectedDeal" || 
						field === "pricePreference"
					) {
						masterStore.methods.changeData({
							...masterStore.state.data,
							[field]: data[field],
						});
					}

					data[field] = null;
				} catch (err) {
					if (model.active) toggleModel();

					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const modelEvent = (event) => {
				const selected = Object.keys(data).filter((key) => data[key] !== null);
				selected.map((item) => updateLead(item));
			};

			const sendMail = async () => {
				try {
					api.isLoading = true;
					await API.privateRequest.get(`/pdf/${masterStore.state.data._id}`);

					toast.success(`Proposal Mail Sent Successfully !`);
					api.isLoading = false;

					data.leadSubStatus = "Sales";
					updateLead("leadSubStatus");
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}
					toast.error(message, true);
				}
			};

			const saveAssignedTo = () => {
				updateLead("assignedTo");
			};
			const saveCurrentUser = () => {
				updateLead("currentUser");
			};
			const saveStatus = () => {
				updateLead("leadStatus");
			};
			const saveSubStatus = () => {
				updateLead("leadSubStatus");
			};
			const savePriority = () => {
				updateLead("leadPriority");
			};
			const saveNote = () => {
				updateLead("notes");
			};

			const paymentAction = async (action, count) => {
				try {
					let key;
					if (isNaN(count)) throw new Error('Unexpected count fn[paymentAction]');
					if (action === 'verify') {
						key = 'verified';
					} else if (action === 'reject') {
						key = 'rejected';
					} else if (action === 'accept_all') {
						key = 'verified';
					} else if (action === 'reject_all') {
						key = 'rejected';
					} else throw new Error('Unexpected action')

					let payments = [...masterStore.state.data.payments];
								
					let changedPayments = payments.map(payment => {
					
						if (action.includes('_all')) {
							if (key == 'verified') payment.rejected = false;
							else payment.verified = false;
							payment[key] = true;
							payment.verifiedBy = store.state.user.id;
						}
						else if (payment.count === count) {
							if (key == 'verified') payment.rejected = false;
							else payment.verified = false;

							payment[key] = true;
							payment.verifiedBy = store.state.user.id;
						}
						return payment;
					});

					masterStore.methods.changeData({ ...masterStore.state.data, payments: [...changedPayments] });
				
			
					await API.privateRequest.patch(`leads/patch-segment/${masterStore.state.data._id}`,{ payments: masterStore.state.data.payments });
					toast.success('payment accepted successfully');

				} catch (error) {
					console.log(error);
					toast.error('payment updation failed!');
					masterStore.methods.changeData({ ...masterStore.state.data, payments });
				}
				
			};

			const showItinerary = ref(false);
			const toggleItinerary = () => showItinerary.value = !showItinerary.value

			const valError = (input) => {};
			const valSuccess = (input) => {};

			return {
				masterStore,
				data,
				api,
				multiSelectState,
				showComponent,
				model,
				showItinerary,

				setAssignedTo,
				setCurrentUser,
				setStatus,
				setPriority,
				setSubStatus,
				setPackageDeal,
				setPricePreference,

				saveAssignedTo,
				saveCurrentUser,
				saveStatus,
				savePriority,
				saveNote,
				saveSubStatus,
				paymentAction,

				toggleItinerary,

				modelEvent,
				sendMail,

				valError,
				valSuccess,
			};
		},
	};
</script>
<style scoped>
	.status-arrow {
		position: relative;
	}

	.custom-height {
		max-height: 200px;
	}

	.status-arrow:after {
		content: "";
		position: absolute;
		top: 0;
		left: 100%;
		height: 0;
		border-radius: none;
		border-top: 16px solid transparent;
		border-bottom: 16px solid transparent;

		border-left: 16px solid #198754;
		background: rgba(0, 0, 0, 0);
		z-index: 0;
	}

	/* .loader {
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		height: 250px;
		width: 250px;
		border-radius: 8px;
		background: var(--custom-dark-bg);
		z-index: 20;
	} */

	.profile {
		height: 100%;
		width: 100%;

		overflow: hidden;
	}
	.user-profile {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
	.paymentWrap {
		height: 350px;
		overflow-y: auto;
		overflow-x: hidden;
	}

</style>
